import { render, staticRenderFns } from "./social-contact.vue?vue&type=template&id=63e95516&scoped=true"
import script from "./social-contact.vue?vue&type=script&lang=js"
export * from "./social-contact.vue?vue&type=script&lang=js"
import style0 from "./social-contact.vue?vue&type=style&index=0&id=63e95516&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e95516",
  null
  
)

export default component.exports